import React, { useState } from 'react';
import { Col, DropdownButton, MenuItem, Row } from 'react-bootstrap';
import { Box, Icon, InfoLabel } from '../../../../common/components';
import ActivateSchemeButton from '../ActivateSchemeButton/ActivateSchemeButton';
import './AdminFeeDetails.scss';
import AdminFeesForm from './components/AdminFeesForm';
import formatDateTime from '../../../../helpers/formatDateTime';

const VersionsDropDown = ({ feeScheme, feeSchemesList, onVersionSelect }) => {
  const schemeStatus = feeScheme && feeScheme.attributes.status;
  const title = `${feeScheme?.attributes?.status} - v${feeScheme?.attributes?.version}`;

  return (
    <div className="scheme-version-dropdown">
      <DropdownButton
        pullRight
        bsSize="small"
        title={title}
        bsStyle={'default'}
        id={'secondDropDown'}
        className={`status-${schemeStatus}`}
        disabled={schemeStatus === 'inactive'}
      >
        {feeSchemesList?.map((scheme) => {
          const displayName = `${scheme.attributes.name} - v${scheme.attributes.version}`;
          return (
            <MenuItem
              key={scheme.id}
              eventKey={`${scheme.id}`}
              onSelect={onVersionSelect}
            >
              <div className="dropdown-item">
                <span>{displayName}</span>
                <div className={`status ${scheme.attributes.status}`}>
                  {' '}
                  -{scheme.attributes.status}
                </div>
              </div>
            </MenuItem>
          );
        })}
      </DropdownButton>
    </div>
  );
};

const ActionsDropDown = ({
  feeScheme,
  isViewOnly,
  onCancel,
  onEditRates,
  omImportRates,
  onNewVersion,
  onActivate,
}) => {
  const schemeStatus = feeScheme && feeScheme.attributes.status;
  const label = schemeStatus === 'test' ? 'View/Edit rates' : 'View rates';

  return (
    <DropdownButton
      pullRight
      bsSize="small"
      title={'Actions'}
      bsStyle={'default'}
      id={'dropdown-scheme-actions'}
      disabled={schemeStatus === 'inactive'}
    >
      {schemeStatus === 'test' && isViewOnly && (
        <MenuItem eventKey="1" onClick={onActivate}>
          <Icon name="check-circle" /> Activate
        </MenuItem>
      )}

      {schemeStatus === 'test' && isViewOnly && (
        <MenuItem eventKey="2" onClick={omImportRates}>
          <Icon name="check-circle" /> Import rates
        </MenuItem>
      )}

      {isViewOnly && (
        <MenuItem eventKey="3" onClick={onEditRates}>
          <Icon name="check-circle" /> {label}
        </MenuItem>
      )}

      {isViewOnly && schemeStatus === 'active' && (
        <MenuItem eventKey="4" onClick={onNewVersion}>
          <Icon name="check-circle" /> New Version
        </MenuItem>
      )}

      {!isViewOnly && (
        <MenuItem eventKey="5" onClick={onCancel}>
          <Icon name="check-circle" /> Cancel New Version
        </MenuItem>
      )}
    </DropdownButton>
  );
};

const AdminFeeDetails = ({
  onEditRates,
  onImportRates,
  feeScheme,
  feeSchemesList,
  onUpdate,
  isLoading,
  onVersionSelect,
  onActivate,
  onActivateComplete,
}) => {
  const [isViewOnly, setIsViewOnly] = useState(true);

  if (!feeScheme) {
    return null;
  }

  const handleNewVersion = () => {
    setIsViewOnly(false);
  };

  const handleCancelNewVersion = () => {
    setIsViewOnly(true);
  };

  const handleActivate = () => {
    onActivate();
  };

  const update = (values) => {
    onUpdate(values);
    setIsViewOnly(true);
  };

  const handleImportRates = () => {
    return onImportRates(feeScheme.id);
  };

  const handleEditRates = () => {
    return onEditRates(feeScheme.id);
  };

  return (
    <>
      <Box className="product-container scheme-container margin-bottom animated fadeIn">
        <div className="admin-fee-header">
          <div className="admin-fee-title">
            <h3>
              {' '}
              {`${feeScheme.attributes.name}`} {isLoading && <Icon spin name="spinner" />}
            </h3>
          </div>
          <VersionsDropDown
            feeScheme={feeScheme}
            feeSchemesList={feeSchemesList}
            onVersionSelect={onVersionSelect}
          />
          <div className="scheme-actions-dropdown">
            <ActionsDropDown
              feeScheme={feeScheme}
              isViewOnly={isViewOnly}
              onCancel={handleCancelNewVersion}
              onNewVersion={handleNewVersion}
              onEditRates={handleEditRates}
              onImportRates={handleImportRates}
              onActivate={handleActivate}
            />
          </div>
        </div>
        <hr />
        {!isViewOnly && (
          <AdminFeesForm
            onUpdate={update}
            onCancel={handleCancelNewVersion}
            feeScheme={feeScheme}
          />
        )}
        {isViewOnly && (
          <Row>
            <Col sm={6}>
              <InfoLabel label="Name" labelSize={4} value={feeScheme.attributes.name} />

              <InfoLabel
                label="Status"
                labelSize={4}
                value={feeScheme.attributes.status}
              />
            </Col>
            <Col sm={6}>
              <InfoLabel
                label="From"
                labelSize={4}
                value={formatDateTime(feeScheme.attributes.from_date)}
              />
              <InfoLabel
                label="To"
                labelSize={4}
                value={formatDateTime(feeScheme.attributes.to_date)}
              />
            </Col>
          </Row>
        )}
      </Box>
      <ActivateSchemeButton
        hideButton
        resource={{ data: feeScheme }}
        label="Activate Scheme"
        schemeType="fee-schemes"
        className="pull-left pad-right"
        onActivationComplete={onActivateComplete}
      />
    </>
  );
};

export default AdminFeeDetails;
